"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MediatedLinkedRdfSourcesAsyncRdfIterator_1 = require("./MediatedLinkedRdfSourcesAsyncRdfIterator");
/**
 * A lazy quad source that creates {@link MediatedLinkedRdfSourcesAsyncRdfIterator} instances when matching quads.
 *
 * @see MediatedLinkedRdfSourcesAsyncRdfIterator
 */
class MediatedQuadSource {
    constructor(cacheSize, context, firstUrl, forceSourceType, mediators) {
        this.cacheSize = cacheSize;
        this.context = context;
        this.firstUrl = firstUrl;
        this.forceSourceType = forceSourceType;
        this.mediators = mediators;
    }
    matchLazy(subject, predicate, object, graph) {
        if (subject instanceof RegExp
            || predicate instanceof RegExp
            || object instanceof RegExp
            || graph instanceof RegExp) {
            throw new Error("MediatedQuadSource does not support matching by regular expressions.");
        }
        const it = new MediatedLinkedRdfSourcesAsyncRdfIterator_1.MediatedLinkedRdfSourcesAsyncRdfIterator(this.cacheSize, this.context, this.forceSourceType, subject, predicate, object, graph, this.firstUrl, this.mediators);
        if (!this.sourcesState) {
            it.setSourcesState();
            this.sourcesState = it.sourcesState;
        }
        else {
            it.setSourcesState(this.sourcesState);
        }
        return it;
    }
    match(subject, predicate, object, graph) {
        return this.matchLazy(subject, predicate, object, graph);
    }
}
exports.MediatedQuadSource = MediatedQuadSource;
//# sourceMappingURL=MediatedQuadSource.js.map